import { type IntlShape } from 'react-intl-next';
import { useSnapshot } from 'valtio';

import { getOrCreateExternalIntlState } from './i18n-state';

/**
 * Loads from the externalMessages object and lazily initialises a new intl object if it has not yet
 * loaded
 */
export function useExternalIntlObject(key: string) {
  const snapshot = useSnapshot(getOrCreateExternalIntlState(key));

  // We get a readonly snapshot of the intl object where we actually need it to be non-readonly
  // in RawIntlProviders
  return snapshot.intl as IntlShape;
}
